// extracted by css-extract-rspack-plugin
export default {"Link":"MetadataLink-module__Link__KK96A"};